<template>
  <li
    v-if="menuItemIsAvailable()"
    class="dropdown dropdown-submenu"
    :class="{
      'show': isOpen,
      'disabled': item.disabled,
      'sidebar-group-active active open': isActive,
      'openLeft': openChildDropdownOnLeft
    }"
    @mouseenter="() => updateGroupOpen(true)"
    @mouseleave="() => updateGroupOpen(false)"
  >
    <b-link
      class="dropdown-item w-100"
      href="#"
      :class="{'dropdown-toggle': item.children}"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title">{{ $t(item.title) }}</span>
    </b-link>
    <ul
      v-if="hasEnabledChildren()"
      ref="refChildDropdown"
      class="dropdown-menu"
      @wheel.stop
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </ul>
    <ul
      v-else-if="isOpen"
      class="dropdown-menu submenu-empty dark-menu"
    >
      <li class="nav-link menu-item">Нет доступных разделов</li>
    </ul>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { resolveHorizontalNavMenuItemComponent as resolveNavItemComponent } from '@/core/layouts/utils'
import HorizontalNavMenuLink
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-link/HorizontalNavMenuLink.vue'

// Composition Function
import useHorizontalNavMenuGroup
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-group/useHorizontalNavMenuGroup'
import mixinHorizontalNavMenuGroup
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-group/mixinHorizontalNavMenuGroup'
import {getUserData} from '@/auth/utils'
import { integratorIsDentalLaboratory } from '@/composables/currentUser'

export default {
  name: 'HorizontalNavMenuGroup',
  components: {
    HorizontalNavMenuLink,
    BLink,
  },
  mixins: [mixinHorizontalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {
      refChildDropdown,
      isActive,
      isOpen,
      updateGroupOpen,
      updateIsActive,
      openChildDropdownOnLeft,
    } = useHorizontalNavMenuGroup(props.item)

    return {
      refChildDropdown,
      openChildDropdownOnLeft,
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    }
  },
  methods: {
    menuItemIsAvailable() {
      if (!this.menuItemIsAvailableByIntegratorModuleSettings()) {
        return false
      }
      if (this.item.route === 'dictionary-dental-laboratory' && !integratorIsDentalLaboratory()) {
        return false
      }
      return this.item.children.some(i => this.$can(i.action, i.resource))
    },
    menuItemIsAvailableByIntegratorModuleSettings() {
      const user = getUserData()
      if (user) {
        if (user.isRoot) {
          return true
        }
        return user.system_modules.includes(this.item.route)
      }
      return true
    },
    hasEnabledChildren() {
      const user = getUserData()
      if (user) {
        if (user.isRoot) {
          return true
        }
        return this.item.children.findIndex(child => user.system_modules.includes(child.route)) > -1
      }
      return true
    }
  }
}
</script>

<style lang='scss'>
.dropdown-submenu.show {
  .dropdown-menu.submenu-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    .dropdown-submenu-item {
      font-style: italic;
      font-size: 13px;
    }
  }
}
</style>
